import { HidableToastNames } from 'src/enums'
import { RootState } from 'src/redux/createRootReducer'

export const selectIsToastOpenFromState = (state: RootState): boolean =>
  state.app.toast.isToastOpen

export const selectToastMessageFromState = (
  state: RootState,
): React.ReactNode | undefined => state.app.toast.toastMessage

export const selectHidableToastNameFromState = (
  state: RootState,
): HidableToastNames | undefined => state.app.toast.hidableToastName

export const selectInProgressColorSchemeFromState = (
  state: RootState,
): boolean | undefined => state.app.toast.inProgressColorScheme

export const selectFailureColorSchemeFromState = (
  state: RootState,
): boolean | undefined => state.app.toast.failureColorScheme

export const selectPartialSuccessColorSchemeFromState = (
  state: RootState,
): boolean | undefined => state.app.toast.partialSuccessColorScheme

export const selectHideImageFromState = (
  state: RootState,
): boolean | undefined => state.app.toast.hideImage

export const selectImageFromState = (
  state: RootState,
): React.ReactNode | undefined => state.app.toast.image

export const selectIsInfinite = (state: RootState): boolean | undefined =>
  state.app.toast.isInfinite

export const selectIsDarkBackground = (state: RootState): boolean | undefined =>
  state.app.toast.isDarkBackground

export const selectForceHideToast = (state: RootState): boolean | undefined =>
  state.app.toast.forceHideToast

export const selectBulkToast = (state: RootState): boolean | undefined =>
  state.app.toast.bulkToast

export const selectHiddenToastsFromState = (
  state: RootState,
): HidableToastNames[] => state.app.toast.hiddenToasts
